/* ============================================================
   E1 · Sticky Add-to-Cart bar · Jormands x ConvertMate
   Loaded by snippets/cm-sticky-atc.liquid on product pages.
   INACTIVE unless <html> has class "cm-e1". Activation:
     - Intelligems variant JS:
         document.documentElement.classList.add('cm-e1');
         document.dispatchEvent(new Event('cm:e1'));
     - or theme setting "cm_sticky_always_on" (adds the class server-side).
   Rule: bar is visible whenever the main "Agregar al carrito" button
   is NOT in the viewport (above OR below). Hidden only while it is.
   Sets [data-cm-stuck] on .sticky-add-to-cart__bar; CSS reacts to it.
   ============================================================ */
(function () {
  'use strict';

  var FLAG_CLASS = 'cm-e1';
  var BAR_HEIGHT_FALLBACK = 80;

  function isActive() {
    return document.documentElement.classList.contains(FLAG_CLASS);
  }

  function setup() {
    if (!isActive()) return;
    var host = document.querySelector('sticky-add-to-cart');
    if (!host || host.dataset.cmStickyInit === 'true') return;
    var bar = host.querySelector('.sticky-add-to-cart__bar');
    var section = host.closest('.shopify-section') || document;
    var target =
      section.querySelector('.buy-buttons-block [ref="addToCartButton"]') ||
      section.querySelector('.buy-buttons-block');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    host.dataset.cmStickyInit = 'true';

    var io = null;

    function setVisible(visible) {
      bar.setAttribute('data-cm-stuck', visible ? 'true' : 'false');
    }

    function observe() {
      if (io) io.disconnect();
      // Exclude the bar's own height from the viewport so the main button
      // does not count as "visible" while it is still covered by the bar.
      var barHeight = Math.round(bar.getBoundingClientRect().height) || BAR_HEIGHT_FALLBACK;
      io = new IntersectionObserver(
        function (entries) {
          var entry = entries[entries.length - 1];
          setVisible(!entry.isIntersecting);
        },
        { root: null, threshold: 0, rootMargin: '0px 0px -' + barHeight + 'px 0px' }
      );
      io.observe(target);
    }

    observe();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(observe, 150);
    });
  }

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  }

  boot();
  // Intelligems (or anything) can activate after this script ran
  document.addEventListener('cm:e1', boot);
  // Theme editor / section re-render safety
  document.addEventListener('shopify:section:load', setup);
})();
